import React, { useState, useEffect } from 'react';
import { Modal } from '../../../../components';
import { verifyTicket } from '../../api';

const VerifyTicket = ({ tryAgainClicks, onVerified, payload }) => {
  const [progress, setProgress] = useState(0);

  const incrementProgress = (interval) => {
    setProgress(prev => {
      if (prev < 100) {
        return prev + 1; 
      } else {
        clearInterval(interval);
        return 99;
      }
    });
  };

  useEffect(() => {
    let interval;
    interval = setInterval(() => {
      incrementProgress(interval);
    }, 1000);

    setTimeout(() => {
      clearInterval(interval);
      interval = setInterval(() => {
        incrementProgress(interval);
      }, 30);

      verifyTicket(payload, (data) => {
        clearInterval(interval);
        onVerified(data);
      }, (err) => {
        clearInterval(interval);
        onVerified(err);
      });
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Modal className='verify-ticket'>
      <div className="flex flex-col items-start justify-start p-8 pb-0 bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="heading-16 self-center">Verifying your ticket</div>
        <div className="text-14 mb-4 self-center">Keep this tab open for 2-3 mins!</div>
        <div className="w-full bg-grey-30 rounded-full h-3.5 mb-4 text-center self-center">
          <div
            className="bg-primary h-3.5 rounded-full self-center"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        <div className="label-16 mb-4 self-center">{progress}%</div>
        <div className="w-full h-32 rounded bg-grey-30 animate-pulse mb-4"></div>
        <div className="w-3/4 h-6 rounded bg-grey-30 animate-pulse mb-2"></div>
        <div className="w-1/2 h-4 rounded bg-grey-30 animate-pulse mb-2"></div>
        <div className="w-1/2 h-4 rounded bg-grey-30 animate-pulse mb-2"></div>
        <div className="w-1/4 h-4 rounded bg-grey-30 animate-pulse mb-4"></div>
        <div className='text-14 bg-light rounded-b-xl w-full p-2 mb-6'>Total Amount</div>
      </div>
    </Modal>
  );
};

export default VerifyTicket;
